import React from 'react';
import { Flex, Typography, Button } from 'antd';

const { Title, Text } = Typography;

/**
 * Component that displays unsupported device message
 * Shows a message asking users to access from PC
 *
 * @returns Unsupported device page component
 */
const UnsupportedDevicePage: React.FC = () => {
  return (
    <Flex
      className="w-[336px] bg-white rounded-3xl flex-col items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      style={{
        padding: '32px',
        minHeight: '285px',
      }}
    >
      {/* Main Title */}
      <Title
        level={2}
        className="!text-[20px] !text-[#2C1662] !font-bold !m-0 !mb-2 !text-center Noto-Sans-JP !leading-[180%] !tracking-[0]"
      >
        PCでのご利用をお願いします
      </Title>

      {/* Body Text */}
      <Flex className="flex-col !mb-4 w-full">
        <Text className="!text-[16px] !block Noto-Sans-JP !leading-[180%] !tracking-[0] !text-[#6E5E83]">
          このサービスは、PCでの操作に最適化されています。
        </Text>
        <Text className="!text-[16px] !block Noto-Sans-JP !leading-[180%] !tracking-[0] !text-[#6E5E83]">
          PC（Windows / Mac）からアクセスしてください。
        </Text>
      </Flex>

      {/* Service Site Button */}
      <Button
        type="primary"
        className="!h-[45px] !text-[14px] !font-medium !rounded-2xl !text-white !bg-[#C395EB] !border-none hover:!bg-[#AF86D3] !shadow-none w-full flex justify-center items-center"
        onClick={() => {
          window.open('https://aivy.tokyo/clp', '_blank', 'noopener noreferrer');
        }}
      >
        サービスサイト
      </Button>
    </Flex>
  );
};

export default React.memo(UnsupportedDevicePage);
